var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.0301 36.4168C77.968 46.7269 71.4672 56.3332 61.7161 59.8941C51.7372 63.5379 40.454 60.4738 33.6633 52.3168C26.9555 44.2633 26.1688 32.4418 31.5516 23.5187C36.9344 14.5543 47.7207 9.77187 57.9895 11.8836C68.1754 13.9746 76.1047 22.2973 77.761 32.5453C77.9473 33.8289 78.0301 35.1332 78.0301 36.4168C78.0508 38.4043 81.1563 38.425 81.1356 36.4168C81.0735 24.6781 73.6825 14.0781 62.6684 9.9996C51.6958 5.92109 38.8184 9.39921 31.3653 18.4258C23.8293 27.5766 22.7321 40.8266 28.9223 51.0125C35.0504 61.0535 46.9961 66.25 58.5071 64.0141C69.8524 61.7988 79.0239 52.2754 80.7629 40.8473C80.9907 39.3773 81.1149 37.9074 81.1149 36.4375C81.1563 34.4293 78.0508 34.4293 78.0301 36.4168ZM4.69966 97.2633C14.9477 87.2223 27.8665 80.1211 42.0688 77.7195C55.4223 75.4629 69.3555 77.5953 81.5497 83.4336C88.8372 86.9324 95.4829 91.632 101.28 97.2633C102.708 98.6504 104.923 96.4558 103.474 95.0687C92.895 84.8414 79.5415 77.4711 64.9872 74.8625C50.9504 72.3367 36.4583 74.2828 23.5188 80.3074C15.7344 83.9512 8.65395 89.0441 2.50513 95.0687C1.07661 96.4558 3.27114 98.6504 4.69966 97.2633Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.600b1a5cacd8ed487443097ddf8719a6.svg";
export { ForwardRef as ReactComponent };